
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private dataSource = new BehaviorSubject<any>(null);
  data$: Observable<any> = this.dataSource.asObservable();

  setData(data: any): void {
    this.dataSource.next(data);
  }

  getData(): Observable<any> {
    return this.data$;
  }

  clearData(): void {
    this.dataSource.next(null);
  }

  patchData(data: any): void {  
    const current = this.dataSource.getValue() || {}
    this.dataSource.next({ ...current, ...data });
  }

  getCurrentData(): any {
    return this.dataSource.getValue();
  }

  clearPreviewState(): void {
    const current = this.dataSource.getValue();
    if (!current) return;
    this.dataSource.next({
      ...current,
      fromNewTask: null,
      restoreFromPreview: false,
      previewSnapshot: null,
      previewReturnRoute: null
    });
  }
  
}
